module.exports = "//cdn.mxpnl.com/static/asset-cache/93cd4a026fe6240b382cd0209e52c3ea/iron/common/assets/images/partner-logos/m-particle.svg";